import UnreadNotifs from "component/unread-notifs";
import {
  FiCreditCard,
  FiGift,
  FiHeart,
  FiHome,
  FiLock,
  FiMail,
  FiMapPin,
  FiPocket,
  FiShoppingBag,
  FiUser,
} from "react-icons/fi";
import { MdOutlineHistory } from "react-icons/md";
import { RxQuestionMarkCircled } from "react-icons/rx";
export const pages = [
  {
    icon: <FiHome />,
    link: "/dashboard/overview",
    title: "Overview",
    skip: true,
    explainer: "Manage your personal details, Edit login, name, and mobile number.",
  },
  {
    icon: <FiUser />,
    link: "/dashboard/profile",
    title: "Your Profile",
    explainer: "Manage your personal details, Edit login, name, and mobile number.",
  },
  {
    icon: <FiShoppingBag />,
    link: "/dashboard/orders",
    title: "Your Orders",
    explainer: "Your orders details are available here",
  },
  {
    icon: <FiMail />,
    link: "/dashboard/notifications",
    title: "Inbox",
    explainer: "Get notified about your orders",
    extra: <UnreadNotifs />,
  },
  {
    icon: <FiMapPin />,
    link: "/dashboard/addresses",
    title: "Your Addresses",
    explainer: "Add, update or delete your saved addresses",
  },
  // {
  //   icon: <FiGift />,
  //   link: "/dashboard/referrals",
  //   title: "Your Referrals",
  //   explainer: "View your referral history, and earn rewards for referring friends!",
  // },
  {
    icon: <FiCreditCard />,
    link: "/dashboard/payments",
    title: "Payment History",
    explainer: "View your payment history",
  },
  {
    explainer: "Review orders",
    icon: <FiHeart />,
    title: "Ratings and Reviews",
    link: "/dashboard/ratings",
  },
  {
    icon: <RxQuestionMarkCircled />,
    link: "/help-and-support",
    title: "Support",
    explainer: "Support",
  },
  {
    icon: <FiLock />,
    link: "/dashboard/security",
    title: "Login & Security",
    explainer: "Manage your login and security details here.",
  },
  {
    icon: <MdOutlineHistory />,
    link: "/dashboard/history",
    title: "History",
    explainer: "History",
  },
  {
    icon: <FiPocket />,
    link: "/dashboard/saved",
    title: "Saved Items",
    explainer: "Saved Items",
  },
  // {
  //   icon: <FiShield />,
  //   link: "/dashboard/data-privacy",
  //   title: "Data & Privacy",
  //   explainer: "Data & Privacy",
  // },
] as const;

export const vendorpages: {
  title: string;
  icon: React.ReactNode;
  link: string;
  extra?: React.ReactNode;
}[] = [
  {
    icon: <FiHome />,
    link: "/vendor/dashboard",
    title: "Dashboard",
  },
  {
    icon: <FiUser />,
    link: "/vendor/listing",
    title: "Your Products",
  },
  {
    icon: <FiShoppingBag />,
    link: "/vendor/orders",
    title: "Your Orders",
  },
  {
    icon: <FiMail />,
    link: "/vendor/notifications",
    title: "Inbox",
    extra: <UnreadNotifs />,
  },
  {
    icon: <FiUser />,
    link: "/vendor/profile",
    title: "Your Profile",
  },
  {
    icon: <RxQuestionMarkCircled />,
    link: "/help-and-support",
    title: "Support",
  },
  {
    icon: <FiLock />,
    link: "/vendor/security",
    title: "Login & Security",
  },
  // {
  //   icon: <MdOutlineHistory />,
  //   link: "/vendor/history",
  //   title: "History",
  // },
  // {
  //   icon: <FiShield />,
  //   link: "/vendor/data-privacy",
  //   title: "Data & Privacy",
  // },
];
